
    var riot = require('riot')
    
riot.tag2('pricetag', '<div class="pricetag panel panel-default"> <div class="panel-heading"> <h5 class="panel-title">Product Details</h5> </div> <div class="panel-body"> <p><strong>{opts.name}</strong><br>Reference: {opts.reference} <buy productid="{opts.productid}" price="{opts.price}" showprice="{true}" showqty="{true}" currency="EUR" vat="{true}"></buy> </p> </div> </div>', '', '', function(opts) {
});
    
  